import now from "lodash/now"
import { SET_LAST_ACTIVITY_TIME } from "constants-lib/actionTypes"

export const setLastActivityTime = (timestamp = now()) => ({
  type: SET_LAST_ACTIVITY_TIME,
  payload: timestamp,
})
